/* eslint-disable no-undef */
import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FORM_PORTAL_ID } from 'constants/form';
// import { Helmet } from 'react-helmet';
import { useInView } from 'react-intersection-observer';
import { BUTTON_THEMES } from 'constants/button';
import URL_PARAMETERS from 'constants/url-parametrs';
import styles from './hubspot-form.module.scss';

const cx = classNames.bind(styles);

const FORM_JS_SRC = 'https://js.hsforms.net/forms/v2.js';

const HubspotForm = ({ targetId, formId, buttonTheme, ...props }) => {
  const [sectionRef, inView] = useInView({ triggerOnce: true });

  // useEffect(() => {
  //   window.addEventListener('message', event => {
  // if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
  //   const form = document.getElementById(`hsForm_${event.data.id}`);
  //   const input = form?.querySelector('input[name="gclid"]');
  //   input.value = localStorage.getItem('gclid') || localStorage.getItem('gclid__c');
  //   input.dispatchEvent(new Event('input', { 'bubbles': true }));
  // }
  // if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
  //   localStorage.setItem('gclid', '');
  //   localStorage.setItem('gclid__c', '');
  // }
  // if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onBeforeFormSubmit') {
  //   debugger
  // }
  //   });
  // }, []);

  // useEffect(() => {
  //   const onHbFormSubmit = (event) => {
  //     if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
  //       window?.dataLayer?.push({
  //         event: 'hubspot-form-success-v2',
  //         'hs-form-guid-v2': event.data.id,
  //         data: event.data.data,
  //       });
  //     }
  //   };
  //   window?.addEventListener('message', onHbFormSubmit);
  //   return () => {
  //     window?.removeEventListener('message', onHbFormSubmit);
  //   };
  // }, []);

  const submitButtonClassNames = `button button_theme_${buttonTheme} button_size_lg hubspot_form_button`;

  const assigningValuesToHiddenFields = () => {
    const inputs = [];

    URL_PARAMETERS.forEach((parameter) => {
      if (parameter === 'irclickid') {
        const input = document.querySelector(`.hs-input[name="click_id"]`);

        if (input) {
          inputs.push(input);
        }
      }

      const input = document.querySelector(`.hs-input[name="${parameter}"]`);

      if (input) {
        inputs.push(input);
      }

      return null;
    });

    if (inputs) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        const param =
          input.getAttribute('name') === 'click_id' ? 'irclickid' : input.getAttribute('name');

        const paramValue = localStorage.getItem(param)
          ? JSON.parse(localStorage.getItem(param)).value
          : '';
        input.value = paramValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    return null;
  };

  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    // Check if the script already exists in the document
    const existingScript = document.querySelector(`script[src="${FORM_JS_SRC}"]`);

    if (existingScript) {
      // If the script already exists, set it as loaded
      setScriptLoaded(true);
    } else {
      // Create a script element if not already loaded
      const script = document.createElement('script');
      script.src = FORM_JS_SRC;
      script.async = true;

      // Set script as loaded once it finishes loading
      script.onload = () => {
        setScriptLoaded(true);
      };

      // Append the script to the body
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    if (inView && formId && scriptLoaded) {
      hbspt?.forms?.create({
        portalId: FORM_PORTAL_ID,
        formId,
        target: `#${targetId}`,
        submitButtonClass: submitButtonClassNames,
        onFormReady: (form) => {
          if (props.onFormReady) {
            props.onFormReady(form);
          }
          assigningValuesToHiddenFields();
        },
        ...props,
      });

      // Pseudo-jQuery for Hubspot callbacks
      (function () {
        window.jQuery =
          window.jQuery ||
          function (nodeOrSelector) {
            if (typeof nodeOrSelector === 'string') {
              return document.querySelector(nodeOrSelector);
            }
            return nodeOrSelector;
          };
      })();
    }
  }, [inView, formId, scriptLoaded]);

  // const handleOnLoad = useCallback(() => {
  //   // eslint-disable-next-line no-undef
  //   hbspt.forms.create({
  //     portalId: FORM_PORTAL_ID,
  //     formId,
  //     target: `#${targetId}`,
  //     submitButtonClass: submitButtonClassNames,
  //     onFormReady: () => assigningValuesToHiddenFields(),
  //     ...props,
  //   });
  //
  //   // Pseudo-jQuery for Hubspot callbacks
  //   (function () {
  //     window.jQuery =
  //       window.jQuery ||
  //       function (nodeOrSelector) {
  //         if (typeof nodeOrSelector === 'string') {
  //           return document.querySelector(nodeOrSelector);
  //         }
  //         return nodeOrSelector;
  //       };
  //   })();
  // }, [formId, targetId, submitButtonClassNames, props]);
  //
  // const handleScriptInject = useCallback(({ scriptTags: existTags }, { scriptTags }) => {
  //   if (scriptTags) {
  //     // If script just has been added
  //     const addedScriptTag = scriptTags[0];
  //     addedScriptTag.onload = handleOnLoad;
  //   } else {
  //     // If script already exist
  //     const hasScript = existTags.some((script) => script.src === FORM_JS_SRC);
  //     if (hasScript) {
  //       handleOnLoad();
  //     }
  //   }
  // }, [handleOnLoad]);

  return (
    <>
      <div className={cx('wrapper')} id={targetId} ref={sectionRef} />
      {/* {inView && ( */}
      {/*  <Helmet */}
      {/*    script={[{ src: FORM_JS_SRC }]} */}
      {/*    // Helmet doesn't support `onload` in script objects so we have to hack in our own */}
      {/*    onChangeClientState={(newState, addedTags) => handleScriptInject(newState, addedTags)} */}
      {/*  /> */}
      {/* )} */}
    </>
  );
};

HubspotForm.defaultProps = {
  buttonTheme: BUTTON_THEMES.ACCENT_PRIMARY,
  onFormReady: null,
};

HubspotForm.propTypes = {
  targetId: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  buttonTheme: PropTypes.oneOf(Object.values(BUTTON_THEMES)),
  onFormReady: PropTypes.func,
};

export default HubspotForm;
